import common from './common';
import account from './account';
import alimtalkSend from './alimtalkSend';
import category from './category';
import event from './event';
import promotionSchedule from './promotionSchedule';
import tag from './tag';

export const ERROR_RESPONSE = {
  ...common,
  ...account,
  ...alimtalkSend,
  ...category,
  ...event,
  ...promotionSchedule,
  ...tag,
};
